export const agreements = [
  {
    title: '개인정보 수집 및 이용 동의',
    content: `
  1. 개인정보 수집 목적
    - 비대면 진료 서비스 제공 및 진료비 결제
    - 처방전을 통한 약 조제 서비스 제공
    - 진료 접수 서비스 개선 및 통계 자료 활용
    - 만 14세 미만의 아동의 개인정보 수집에 대한 동의 근거
  2. 수집 항목
    - 필수항목 : 성명, 생년월일, 처방전, 신용카드번호
  3. 이용 기간
    - 회원 탈퇴 시 까지
  4. 동의 거부 시 불이익
    - 귀하는 개인정보의 수집‧이용에 대한 동의를 거부할 수 있습니다. 다만, 동의 거부 시 비대면 진료 서비스를 이용할 수 없습니다.
  `
  },
  {
    title: '개인정보 제3자 제공 동의',
    content: `
  1. 제공받는자
    - 비대면 진료 서비스 제공 병원
  2. 제공하는 목적
    - 비대면 진료 서비스 제공 및 본인 확인
    - 진료비 청구, 수납, 환급 등의 원무 서비스, 진료비계산서, 진료비내역서, 처방전 발행, 제증명 관련 서비스
  3. 제공하는 개인정보 항목
    - 성명, 주민등록번호, 생년월일, 진료항목, 증상 (설명 및 사진 포함)
  4. 이용 기간
    - 진료기록부 : 10년
    * 「의료법」시행규칙 제15조(진료기록부 등의 보존),「국민건강보험법」제96조의2(서류의 보존) 등 관련 법령을 기준으로 보존 합니다.
  5. 동의 거부 시 불이익
    - 귀하는 개인정보의 제3자 제공 동의를 거부할 수 있습니다. 다만, 동의 거부 시 비대면 진료 서비스를 이용할 수 없습니다.
  `
  },
  {
    title: '고유식별정보 수집 동의',
    content: `
  병의원은 본인 확인 및 건강보험가입 여부 확인을 위하여 주민등록번호를 의료법 시행령 제42조의2(민감정보 및 고유식별정보의 처리)에 따라 처리할 수 있으며, 굿닥은 비대면 진료 서비스 병의원과 개인정보 위수탁 계약을 통해 권한을 위함 받아 주민등록번호를 수집 하고 있습니다.
  1. 고유식별정보 수집 받는자
    - 굿닥
  2. 고유식별정보 수집 목적
    - 비대면 진료 서비스 이용에 따른 본인 확인
    - 진료비 청구, 수납, 환급 등의 원무 서비스, 진료비계산서, 진료비내역서, 처방전 발행, 제증명 관련 서비스
  3. 고유식별정보 항목
    - 주민등록번호
  4. 이용 기간
    - 회원 탈퇴 시 까지
  5. 동의 거부 시 불이익
    - 귀하는 고유식별정보의 수집‧이용에 대한 동의를 거부할 수 있습니다. 다만, 동의 거부 시 비대면 진료 접수 서비스를 이용할 수 없습니다.
  `
  },
  {
    title: '민감정보 수집 동의',
    content: `
  원활한 비대면 진료 서비스를 제공을 위해 진료항목 및 처방전을 수집하고 있습니다. 처방전은 안전한 암호화 알고리즘을 이용하여 저장하고 있고 개인정보 보호을 위한 기술적 관리적 보호 조치를 취하고 있습니다. 
  1. 고유식별정보 수집 받는자
    - 굿닥
  2. 민감정보 수집 목적
    - 비대면 진료 서비스 제공
    - 처방을 통한 약 조제 서비스 제공
  3. 민감정보 항목
    - 필수항목 : 진료항목, 처방전
    - 선택항목 : 증상, 사진
  4. 이용 기간
    - 회원 탈퇴 시 까지(단, 타 법령에 따라 보존 할 수 있음)
  5. 동의 거부 시 불이익
    - 귀하는 고유식별정보의 수집‧이용에 대한 동의를 거부할 수 있습니다. 다만, 동의 거부 시 비대면 진료 접수 서비스를 이용할 수 없습니다.
  `
  }
];

export const wholeContentTitle = '굿닥 비대면 진료 서비스 이용 약관';
